(function(root){
  async function convert({read,change,add,remove,key,plan,variant,target=variant,groupOf}){
    let cart=await read();
    const original=cart.items.find(item=>item.key===key);
    if(!original||String(original.variant_id)!==String(variant)||original.selling_plan_allocation)throw new Error('stale');
    if(!Number.isSafeInteger(original.quantity)||original.quantity<1)throw new Error('stale');
    const group=groupOf(original);
    if(!group||groupOf({variant_id:target})?.slug!==group.slug)throw new Error('unavailable');
    if(cart.items.some(item=>item.key!==key&&item.selling_plan_allocation&&groupOf(item)?.slug===group.slug))throw new Error('duplicate');
    const properties={...original.properties};
    if('_pp_one_time' in properties)properties._pp_one_time='false';
    if(String(target)!==String(variant)){
      const marker='pp-'+Date.now()+'-'+Math.random().toString(36).slice(2);
      properties._pp_cart_switch=marker;
      await add({items:[{id:Number(target),quantity:1,selling_plan:Number(plan),properties}]});
      cart=await read();
      const added=cart.items.find(item=>item.properties?._pp_cart_switch===marker);
      if(!added||!added.selling_plan_allocation)throw new Error('changed');
      try{await remove({id:key,quantity:original.quantity-1});}
      catch(error){
        cart=await read();
        if(cart.items.some(item=>item.key===key&&item.quantity===original.quantity)){
          const rollback=cart.items.find(item=>item.properties?._pp_cart_switch===marker);
          if(rollback)await remove({id:rollback.key,quantity:0});
          throw error;
        }
      }
      cart=await read();
      const index=cart.items.findIndex(item=>item.properties?._pp_cart_switch===marker);
      if(index<0)throw new Error('changed');
      cart=await change({line:index+1,quantity:1,selling_plan:Number(plan),properties});
    }else{
      cart=await change({line:cart.items.indexOf(original)+1,quantity:original.quantity,selling_plan:Number(plan),properties});
    }
    if(cart.errors||!cart.items.some(item=>String(item.variant_id)===String(target)&&String(item.selling_plan_allocation?.selling_plan.id)===String(plan)))throw new Error('changed');
    return cart;
  }
  if(typeof module!=='undefined'&&module.exports){module.exports=convert;return;}
  if(root.PPCartRefillLoaded)return;
  root.PPCartRefillLoaded=true;
  let busy=false;
  const states=new WeakMap();
  function clearNotice(drawer){drawer?.querySelectorAll('[data-pp-switch-error]').forEach(notice=>notice.remove());}
  function init(box){
    if(states.has(box))return states.get(box);
    const options=JSON.parse(box.dataset.options);
    const state={options,country:null,plan:null};states.set(box,state);
    const countries=[...new Set(options.map(option=>option.country))];
    const plans=[...new Map(options.map(option=>[option.plan,option])).values()];
    function button(text,field,value){const b=document.createElement('button');b.type='button';b.textContent=text;b.dataset[field]=value;b.setAttribute('aria-pressed','false');return b;}
    countries.forEach(country=>box.querySelector('[data-countries]').append(button(country,'country',country)));
    plans.forEach(plan=>box.querySelector('[data-plans]').append(button(plan.label,'plan',plan.plan)));
    return state;
  }
  function update(box,state){
    box.querySelectorAll('[data-plan]').forEach(b=>{
      b.disabled=Boolean(state.country&&!state.options.some(o=>o.country===state.country&&String(o.plan)===b.dataset.plan));
      if(b.disabled&&String(state.plan)===b.dataset.plan)state.plan=null;
      b.setAttribute('aria-pressed',String(String(state.plan)===b.dataset.plan));
    });
    const selected=state.options.find(o=>o.country===state.country&&String(o.plan)===String(state.plan));
    box.querySelector('[data-apply]').disabled=!selected;
    if(selected)box.querySelector('[data-terms]').textContent=selected.terms;
    const intro=box.querySelector('[data-intro]');if(intro)intro.hidden=Boolean(state.country&&state.country!=='US');
  }
  document.addEventListener('click',async event=>{
    if(busy&&event.target.closest('cart-drawer')){event.preventDefault();event.stopImmediatePropagation();return;}
    const trigger=event.target.closest('button');
    if(!busy&&event.target.closest('cart-drawer')&&event.target.closest('button,a,input'))clearNotice(event.target.closest('cart-drawer'));
    const box=trigger?.closest('[data-pp-refill]');if(!box)return;
    const state=init(box);
    clearNotice(box.closest('cart-drawer'));
    if(trigger.hasAttribute('data-explore')){
      const expanded=trigger.getAttribute('aria-expanded')==='true';trigger.setAttribute('aria-expanded',String(!expanded));box.querySelector('[data-selection]').hidden=expanded;return;
    }
    if(trigger.hasAttribute('data-country')){
      state.country=trigger.dataset.country;box.querySelectorAll('[data-country]').forEach(b=>b.setAttribute('aria-pressed',String(b===trigger)));update(box,state);return;
    }
    if(trigger.hasAttribute('data-plan')){state.plan=trigger.dataset.plan;update(box,state);return;}
    if(!trigger.hasAttribute('data-apply'))return;
    const selected=state.options.find(o=>o.country===state.country&&String(o.plan)===String(state.plan));if(!selected)return;
    const labels=JSON.parse(box.dataset.labels),status=box.querySelector('[data-status]');
    const drawer=box.closest('cart-drawer');
    busy=true;box.setAttribute('aria-busy','true');drawer?.classList.add('pp-refill-busy');trigger.disabled=true;status.hidden=false;status.textContent=labels.loading;
    const base=root.Shopify?.routes?.root||'/';
    const sections=[];document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections',{bubbles:true,detail:{sections}}));
    const signal=AbortSignal.timeout(30000);
    const read=async()=>{const res=await fetch(base+'cart.js',{signal,cache:'no-store',headers:{Accept:'application/json'}});if(!res.ok)throw new Error('unavailable');return res.json();};
    const raw=async(path,payload)=>{const res=await fetch(base+path,{signal,method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});const data=await res.json();if(!res.ok||data.errors)throw new Error('rejected');return data;};
    try{
      if(!root.PPSubscription)throw new Error('unavailable');
      const result=await convert({read,key:box.dataset.key,variant:box.dataset.original,target:selected.variant,plan:selected.plan,groupOf:root.PPSubscription.rules.groupOf,add:payload=>raw('cart/add.js',payload),remove:payload=>raw('cart/change.js',payload),change:async payload=>{
        const res=await root.PPSubscription.request(base+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname}),signal},{signal,inlineErrors:true});const data=await res.json();if(!res.ok)throw new Error('rejected');return data;
      }});
      clearNotice(drawer);
      box.hidden=true;
      if(root.theme?.pubsub&&result.sections)root.theme.pubsub.publish(root.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{source:'pp-refill',cart:result});
      else document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    }catch(error){
      clearNotice(drawer);
      const notice=document.createElement('p');notice.dataset.ppSwitchError='';notice.className='pp-refill__status';notice.setAttribute('role','alert');notice.textContent=labels[error.message]||labels.error;
      drawer?.querySelector('.drawer__header')?.after(notice);
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    }finally{busy=false;status.hidden=true;box.removeAttribute('aria-busy');drawer?.classList.remove('pp-refill-busy');trigger.disabled=false;}
  },true);
  document.addEventListener('submit',event=>{if(busy&&event.target.closest('cart-drawer')){event.preventDefault();event.stopImmediatePropagation();}},true);
})(typeof window==='undefined'?globalThis:window);
